import React from "react";
import PropTypes from "prop-types";
import { Button, Spinner } from "reactstrap";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import CustomInput from "@/shared/components/form/CustomInput";
import {
  useAddMutation,
  useUpdateMutation,
} from "@/services/pcApi";
import { MEDIA_TAG } from "@/shared/tagFile";
import { successToast } from "@/shared/components/toast";

const MediaTypeForm = ({ editData, setIsAddModalOpen }) => {
  const [addMediaType, { isLoading: isMediaTypeAddLoading }] =
    useAddMutation();
  const [updateMediaType, { isLoading: isMediaTypeUpdateLoading }] =
    useUpdateMutation();

  const mediaTypeValidationSchema = Yup.object().shape({
    Name: Yup.string().required("Please enter name."),
  });

  const onSubmit = (values) => {
    if (editData && Object.entries(editData).length > 0) {
      values.Id = editData.Id;
      updateMediaType({
        entity: "CMSReference/MediaType",
        data: values,
        tag: MEDIA_TAG,
      }).then((response) => {
        if (!response.error) {
          !isMediaTypeUpdateLoading && setIsAddModalOpen(false);
          successToast("Media-type updated successfully.");
        }
      });
    } else {
      addMediaType({
        entity: "CMSReference/MediaType",
        data: values,
        tag: MEDIA_TAG,
      }).then((response) => {
        if (!response.error) {
          !isMediaTypeAddLoading && setIsAddModalOpen(false);
          successToast("Media-type added successfully.");
        }
      });
    }
  };

  return (
    <Formik
      initialValues={{
        Name: editData && editData.Name ? editData.Name : "",
        Description:
          editData && editData.Description ? editData.Description : "",
      }}
      validationSchema={mediaTypeValidationSchema}
      onSubmit={onSubmit}
    >
      {(formik) => {
        const {
          errors,
          touched,
          values,
          handleSubmit,
          handleBlur,
          handleChange,
        } = formik;

        return (
          <Form>
            {Object.keys(editData ?? {}).length > 0 && <CustomInput label="Id" fieldValue={editData.Id} readonly />}
            <CustomInput
              label="Name"
              name="Name"
              fieldErrors={errors.Name}
              fieldTouched={touched.Name}
              fieldValue={values.Name}
              handleBlur={handleBlur}
              handleChange={handleChange}
              required
            />
            <CustomInput
              label="Description"
              name="Description"
              type="textarea"
              fieldErrors={errors.Description}
              fieldTouched={touched.Description}
              fieldValue={values.Description}
              handleBlur={handleBlur}
              handleChange={handleChange}
            />
            <Button
              disabled={
                isMediaTypeAddLoading || isMediaTypeUpdateLoading
              }
              onClick={handleSubmit}
              className="modal_ok float-right"
              color="success"
            >
              {(isMediaTypeAddLoading ||
                isMediaTypeUpdateLoading) && (
                  <Spinner size="sm" variant="light" />
                )}{" "}
              Save
            </Button>
          </Form>
        );
      }}
    </Formik>
  );
};

MediaTypeForm.propTypes = {
  editData: PropTypes.object.isRequired,
  setIsAddModalOpen: PropTypes.func.isRequired,
};

export default MediaTypeForm;
